<template>
  <div>
    <v-card width="auto" height="600px" flat v-if="txnstatus == 0">
      <v-row style="margin-top: 120px">
        <v-card-title
          class="black--text mt-8"
          style="font-size: 28px; margin-left: 600px"
          ><v-icon color="green" class="mr-4"> mdi-check-circle</v-icon> Payment
          Successful!</v-card-title
        >
        <v-col
          cols="12"
          sm="12"
          xs="12"
          xl="12"
          md="12"
          style="margin-left: 665px"
        >
          <v-card-text style="margin-top: -30px">
            <span class="primary--text ml-2" style="font-size: 22px">
              Dear Customer,<br />
            </span>
            <br />
            <span class="black--text ml-n16" style="font-size: 20px">
              Your Transaction is Successful!<br />
            </span>
            <br />
            <span class="black--text ml-7" style="font-size: 18px">
              Thank You.
            </span>
            <br />
            <v-btn
              color="primary"
              @click="routeBack()"
              style="margin-left: -70px; margin-top: 30px"
              width="300px"
            >
              <v-icon class="mr-2 ml-n1" small>mdi-reply</v-icon>
              Back
            </v-btn>
          </v-card-text>
        </v-col>
      </v-row>
    </v-card>
    <v-card width="auto" height="600px" flat v-if="txnstatus == 1">
      <v-row style="margin-top: 120px">
        <v-card-title
          class="red--text mt-8"
          style="font-size: 28px; margin-left: 715px"
        >
          <b>Oops!</b></v-card-title
        >
        <v-col
          cols="12"
          sm="12"
          xs="12"
          xl="12"
          md="12"
          style="margin-left: 615px"
        >
          <v-card-text>
            <span class="primary--text ml-13" style="font-size: 22px">
              Dear Customer,<br />
            </span>
            <br />
            <span class="black--text ml-n12" style="font-size: 20px">
              Your Transaction Has Been Cancelled!
              <v-icon class="mt-n1" color="red"
                >mdi-emoticon-dead-outline</v-icon
              >
              <br />
            </span>
            <span class="black--text ml-n14" style="font-size: 20px">
              We Couldn't Process Your Online Payment.
            </span>
            <br />
            <span class="black--text ml-16" style="font-size: 20px"> </span>
            <br />
            <v-btn
              color="primary"
              @click="routeBack()"
              style="margin-left: -20px; margin-top: 30px"
              width="300px"
            >
              <v-icon class="mr-2 ml-n1" small>mdi-reply</v-icon>
              Back
            </v-btn>
          </v-card-text>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>
<script>
export default {
  data: () => ({
    getpath: "",
    txnstatus: "",
  }),

  created() {
    var hash = window.location.hash;
    this.getpath = hash;
  },
  mounted() {
    if (this.getpath.length != 1) {
      this.txnstatus = this.getpath
        .split("#")[1]
        .split("/")[1]
        .split("&")[8]
        .split("TxnStatus=")[1];
    }
  },

  methods: {
    routeBack() {
      this.$router.push("/corporatefundrequest");
    },
  },
};
</script>
